import { createStyle } from "~/common/utils/create-style";

export const backgroundColors = [
  "yellow",
  "purple",
  "cyan",
  "mint",
  "fushia",
] as const;

export type BackgroundColor = (typeof backgroundColors)[number];

const textIconStyle = createStyle({
  slots: {
    container: [
      "relative overflow-hidden rounded-[5px] flex items-center justify-center",
      "text-black",
    ],
  },
  variants: {
    background: {
      yellow: { container: "bg-system-accent-yellow-02" },
      purple: { container: "bg-system-accent-purple-02" },
      cyan: { container: "bg-system-accent-cyan-02" },
      mint: { container: "bg-system-accent-mint-02" },
      fushia: { container: "bg-system-accent-fushia-02" },
    },
    size: {
      small: { container: "size-20" },
      large: {
        container: "w-[48px] h-[48px] rounded-[12px] text-title-3",
      },
    },
  },
  defaultVariants: {
    size: "small",
  },
})();

export { textIconStyle };
